import React from "react";
import Marquee from "react-fast-marquee";
import { techLogos } from "../../data/content";

/**
 * Editorial slow marquee for tech/tools trust bar.
 * Uses monochrome wordmarks (typography-based) to keep it premium & fast.
 */
export default function TrustBar() {
  return (
    <section
      className="relative bg-white border-y border-brand-border py-10"
      aria-label="Technologie- und Plattform-Partner"
      data-testid="trust-bar"
    >
      <div className="max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 mb-6 flex items-baseline justify-between">
        <p className="eyebrow-muted">Vertrauen &amp; Plattformen</p>
        <p className="text-sm text-brand-muted hidden md:block">
          Wir arbeiten nativ auf den Kanälen, auf denen Ihre Kunden sind.
        </p>
      </div>

      <div className="marquee-mask">
        <Marquee
          speed={35}
          gradient={false}
          pauseOnHover
          autoFill
          aria-hidden
        >
          {techLogos.map((name, i) => (
            <span
              key={`${name}-${i}`}
              className="mx-10 lg:mx-14 text-3xl lg:text-4xl font-semibold text-brand-primary/40 hover:text-brand-primary transition-colors tracking-tight"
              style={{ letterSpacing: "-0.02em" }}
            >
              {name}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
